import script from "./EchartBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EchartBox.vue?vue&type=script&setup=true&lang=js"

import "./EchartBox.vue?vue&type=style&index=0&id=e3882ee4&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3882ee4"]])

export default __exports__